import ApiService from '../../../../../../services/ApiService'

export default {
  name: 'ResponsibleServicesByWeek',

  props: {
    filterProp: Object,
  },

  data() {
    return {
      services: [],
      loading: false,
      apiService: new ApiService(),
      page: 1,
      pageSize: 10,
      headers: [{ text: 'Responsável', value: 'responsible', align: 'center' }],
      headerProps: {
        sortByText: 'Ordenar por',
      },
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.services.length / this.pageSize)
    },
    paginatedItems() {
      const start = (this.page - 1) * this.pageSize
      const end = this.page * this.pageSize
      return this.services.slice(start, end)
    },
  },
  watch: {
    page() {
      this.paginatedItems
    },
    filterProp: {
      handler() {
        this.fetchData()
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    async fetchData() {
      this.loading = true
      try {
        const response = await this.apiService.post(
          'reports/responsibleServicesByWeek',
          this.filterProp
        )
        this.services = response.content || []
        if (this.services.length > 0 && this.services[0].weeks) {
          this.headers = [
            { text: 'Responsável', value: 'responsible', align: 'center' },
            ...this.services[0].weeks.map((x) => {
              return { text: x.week, value: 'weekvalue', align: 'center' }
            }),
          ]
        }
      } catch (error) {
        console.error('Erro ao buscar dados:', error)
        this.services = []
      } finally {
        this.loading = false
      }
    },
  },
}
